/**
 * Returns today's date as a string in YYYY-MM-DD format,
 * using local timezone (not UTC).
 *
 * This avoids off-by-one-day issues that occur when using
 * new Date().toISOString().split('T')[0] around midnight,
 * since toISOString() uses UTC.
 */
export function getTodayLocalDateString(): string {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

